import { createAction } from "redux-actions";
import { api } from "../../services";
import endPoints from "../../services/apiEndPoints";
import {
  PROFITBILITY_REQUEST,
  PROFITBILITY_SUCCESS,
  TENANTS_LIST_REQUEST,
  TENANTS_LIST_SUCCESS,
  UNITS_LIST_REQUEST,
  UNITS_LIST_SUCCESS,
} from "./types";

const tenantsListRequest = createAction(TENANTS_LIST_REQUEST);
const tenantsListSuccess = createAction(TENANTS_LIST_SUCCESS);

const unitsListRequest = createAction(UNITS_LIST_REQUEST);
const unitsListSuccess = createAction(UNITS_LIST_SUCCESS);

const profitbilityRequest = createAction(PROFITBILITY_REQUEST);
const profitbilitySuccess = createAction(PROFITBILITY_SUCCESS);

export const getTenantsList = () => async (dispatch) => {
  dispatch(tenantsListRequest());
  return api
    .get(`${endPoints.TENANTS}`)
    .then((res) => {
      dispatch(tenantsListSuccess(res?.data));
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getUnitsList = () => async (dispatch) => {
  await dispatch(unitsListRequest());
  return api
    .get(`${endPoints.UNITS_LIST}`)
    .then((res) => {
      dispatch(unitsListSuccess(res?.data));
      return res;
    })
    .catch((error) => {
      throw error;
    });
};

export const getProfitbility = () => async (dispatch) => {
  await dispatch(profitbilityRequest());
  return api
    .get(`${endPoints.TENANTS_PROFITABILITY}`)
    .then((res) => {
      dispatch(profitbilitySuccess(res?.data));
      return res;
    })
    .catch((error) => {
      throw error;
    });
};
